(function () {
  'use strict';

  var rafId = null;

  function syncWrap(wrap) {
    var text = wrap.querySelector('span');
    if (!text) return;

    wrap.style.width = 'auto';

    var contentWidth = text.getBoundingClientRect().width;

    if (!contentWidth) return;

    wrap.style.width = (contentWidth + 1) + 'px';
  }

  function syncAll() {
    var items = document.querySelectorAll('[data-ss-section-title-wrap]');
    for (var i = 0; i < items.length; i++) {
      syncWrap(items[i]);
    }
  }

  function scheduleSync() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(syncAll);
  }

  function init() {
    syncAll();

    window.addEventListener('resize', scheduleSync, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncAll);
    }

    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', scheduleSync);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.__ssSectionTitleSync = syncAll;
})();